// src/pages/ChatbotTest/ChatbotTest.js
import React from "react";
import ChatGPTStyleInterface from "../../components/ChatGPTStyleInterface";
import "./ChatbotTest.css";

function ChatbotTest() {
  return (
    <div className="chatbot-test-container">
      <div className="chatbot-header">
        <h1>AI Assistant Test</h1>
        <p>
          Interact with our AI assistant below. Try asking about scheduling,
          tasks, or research.
        </p>
      </div>

      <ChatGPTStyleInterface />
    </div>
  );
}

export default ChatbotTest;
